import React from 'react';
import './ndoeUi.css';

/**
 * NdoeEmpty — état vide.
 * Props : icon, title, text, action (node)
 */
export function NdoeEmpty({ icon = '📭', title = 'Aucun résultat', text, action, className = '' }) {
  return (
    <div className={`ndoe-empty ${className}`}>
      <div className="ndoe-empty__icon">{icon}</div>
      {title ? <div className="ndoe-empty__title">{title}</div> : null}
      {text ? <div className="ndoe-empty__text">{text}</div> : null}
      {action}
    </div>
  );
}

/**
 * NdoeLoading — squelettes shimmer (liste de cartes).
 * Props : rows (nombre de cartes fantômes, défaut 4)
 */
export function NdoeLoading({ rows = 4, className = '' }) {
  return (
    <div className={`ndoe-mobile-list ${className}`} aria-busy="true" aria-live="polite">
      {Array.from({ length: rows }).map((_, i) => (
        <div className="ndoe-skel ndoe-skel-card" key={i} />
      ))}
    </div>
  );
}

/**
 * NdoeError — état d'erreur avec retry.
 * Props : title, text, onRetry
 */
export function NdoeError({ title = 'Une erreur est survenue', text, onRetry, className = '' }) {
  return (
    <div className={`ndoe-error ${className}`}>
      <div className="ndoe-error__icon">⚠️</div>
      <div className="ndoe-error__title">{title}</div>
      {text ? <div className="ndoe-error__text">{text}</div> : null}
      {typeof onRetry === 'function' ? (
        <button type="button" className="ndoe-btn ndoe-btn--secondary" onClick={onRetry}>
          Réessayer
        </button>
      ) : null}
    </div>
  );
}
